import {
  REFRESH_TOKEN_LOCAL_STORAGE_NAME,
  SESSION_TOKEN_LOCAL_STORAGE_NAME
} from "@outschool/auth-shared";
import { isLocalStorageSupported } from "@outschool/local-storage";
import Cookie from "js-cookie";
import { useCallback } from "react";

import * as Env from "../Env";
import { learnerRoutes, websiteRoutes } from "../Routes";

const reviewAppCookie = "x-outschool-use-learner-mode";

export function switchToLearnerModeWithToken({
  transferToken,
  learnerAppUrl,
  isLearnerLogin
}: {
  transferToken: string;
  learnerAppUrl?: string;
  isLearnerLogin?: boolean;
}) {
  if (Env.isReviewApp) {
    // HACK: We use a custom cookie in order to avoid supporting an
    // extra subdomain in Review apps.
    Cookie.set(reviewAppCookie, "true");
  }

  clearLearnerTokenLocalStorageData();
  // TODO: should this use the navigation hook?
  /* eslint-disable-next-line no-restricted-syntax */
  window.location.href = learnerRoutes.authCodeTransferUrl({
    transferToken,
    learnerAppUrl,
    isLearnerLogin
  });
}

export function useSwitchToParentMode(redirect?: string) {
  return useCallback(
    (transferToken: string) => {
      clearLearnerTokenData();
      /* eslint-disable-next-line no-restricted-syntax */
      window.location.href = websiteRoutes.parentAuthCodeTransferUrl(
        transferToken,
        redirect
      );
    },
    [redirect]
  );
}

function clearLearnerTokenLocalStorageData() {
  const localStorage = isLocalStorageSupported();
  localStorage?.removeItem(SESSION_TOKEN_LOCAL_STORAGE_NAME);
  localStorage?.removeItem(REFRESH_TOKEN_LOCAL_STORAGE_NAME);
}

function clearLearnerTokenCookieData() {
  Cookie.remove(reviewAppCookie);
  Cookie.remove("learnerToken");
}

export function clearLearnerTokenData() {
  clearLearnerTokenLocalStorageData();
  clearLearnerTokenCookieData();
}

export function clearLearnerTokenDataAndGoToMainApp() {
  clearLearnerTokenData();
  /* eslint-disable-next-line no-restricted-syntax */
  window?.location.replace(websiteRoutes.baseUrl);
}
